import { atom } from "jotai";

export const userProfileAtom = atom(null);
export const isEditProfileAtom = atom(false);
export const listsTermOfPaymentAtom = atom([]);
export const pickupLoactionsAtom = atom([]);
